import { createAction, props } from '@ngrx/store';
import { StartSession } from '@shared/models/start-session';

export const startSession = createAction('[Login] Start Session', props<{ data: StartSession }>());

export const startSessionSuccess = createAction('[Login] Start Session Success');

export const startSessionFailure = createAction('[Login] Start Session Failure', props<{ error: any }>());
